module.exports = __webpack_public_path__ + "static/media/power.48677330.svg";